import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const SORT_WIRING: Wiring = {
  [EVENTS.SortToggleClicked]: [
    WIRES.toggleSortList
  ],
  [EVENTS.SortClicked]: [
    WIRES.trackSort,
    WIRES.setSort,
    WIRES.collapseSort,
    WIRES.search
  ]
};
